import * as types from './actionTypes';
import PrivateAPIResource from "../services/PrivateAPIResource";

export function loadCompetenciesSuccess(competencies) {
    return {
        type: types.LOAD_COMPETENCIES_SUCCESS,
        competencies,
    };
}

export function loadCompetenciesFail(err, contentType) {
    return {
        type: types.LOAD_COMPETENCIES_FAIL,
        contentType,
        err,
    };
}


export function updateCompetencySuccess(competencies) {
    return {
        type: types.UPDATE_COMPETENCY_SUCCESS,
        competencies,
    };
}

export function addCompetencySuccess(competencies) {
    return {
        type: types.ADD_COMPETENCY_SUCCESS,
        competencies
    }
}


export function competencyDeletedSuccess(competencies) {
    return {
        type: types.DELETE_COMPETENCY_SUCCESS,
        competencies
    }
}

export function fetchCompetencies(contentType) {
    return function (dispatch) {
        return PrivateAPIResource.all('supplier-competencies', {tree: 1})
            .then(competencies => {
                dispatch(loadCompetenciesSuccess(competencies))
            })
            .catch(err => {
                dispatch(loadCompetenciesFail(err.message, contentType));
            });
    }
}


export function addCompetency(contentType, params) {
    return function (dispatch) {
        return PrivateAPIResource.create('supplier-competencies', params)
            .then(competencies => {
                dispatch(addCompetencySuccess(competencies))
            })
            .catch(err => {
                dispatch(loadCompetenciesFail(err.message, contentType));
            });
    }
}

export function updateCompetency(contentType, params) {
    return function (dispatch) {
        return PrivateAPIResource.put(`supplier-competencies/${params.id}`, params)
            .then(competencies => {
                dispatch(updateCompetencySuccess(competencies))
            })
            .catch(err => {
                dispatch(loadCompetenciesFail(err.message, contentType));
            });
    }
}

export function deleteCompetency(contentType, id) {
    return function (dispatch) {
        return PrivateAPIResource.remove('supplier-competencies', id)
            .then(competencies => competencyDeletedSuccess(competencies))
            .catch(err => {
                dispatch(loadCompetenciesFail(err.message, contentType));
//                console.error(err);
            });
    }
}



// WEBPACK FOOTER //
// ./web/src/actions/competenciesTreeEditorActions.js